export default host => (channelId) => `${host}/channels/${channelId}`
